import React from 'react';
import classnames from 'classnames';
import Tags from '../productCollection/Tags';
import { GraphLegend } from '../productRelatednessGraph/graphLegend/GraphLegend';
import { ProductRelatednessGraph } from '../productRelatednessGraph/ProductRelatednessGraph';
import { AdvancedProductCard } from '../advancedProductCard/AdvancedProductCard';
import { IProductDescription } from '../../../models/product/IProductDescription';

import './product-details-panel.scss';

export interface IProduct {
    id: any;
    title: string;
    description?: string;
    tags?: string[];
    link?: string;
    contentLink?: string;
    productType?: string;
}

export interface IRelatedProduct extends IProductDescription {
    isInReadingList: boolean;
}

export interface IProps {    
    product: IProduct;
    relatedProduct: IRelatedProduct;
    
    coverPlaceholder: string;
    wideCoverPlaceholder: string;

    onProductDetailsRequested: (id: any) => void;
    
    onAddToReadingListRequested: (product: IProductDescription) => void;

    showRemoveFromReadingList?: boolean;
    onRemoveFromReadingList?: (product: IProductDescription) => void; 

    children?: React.ReactNode;
}

export interface IState {
}

export class ProductDetailsPanel extends React.Component <IProps, IState> {
    private root: HTMLElement;
    
    constructor(props: IProps) {
        super(props);

        this.handleGraphLoadingFailure = this.handleGraphLoadingFailure.bind(this);
        this.handleRootRef = this.handleRootRef.bind(this);

        this.state = {};
    }

    public render(){
        const product = this.props.product;
        if(product == null) { return null; }

        let link = product.link;
        if(product.productType == "series" && product.contentLink){
            link = product.contentLink;
        }
        
        return <div className={classnames("product-details-panel-root", {"is-open": product != null })} ref={this.handleRootRef}>
                    <div>
                        <div className="product-details-text-details-part">
                            <h5>{product.title}</h5>
                            <a className="product-details-text-description" href={link} dangerouslySetInnerHTML={{__html: product.description}}></a>
                            { product.tags && <Tags tags={product.tags}/>}
                            { this.props.children }
                        </div>
                        <div className="product-details-graph-details-part" style={{visibility: "visible"}}>
                            <h5>recomended reading:</h5>
                            <ProductRelatednessGraph productId={product.id}
                                                     productTitle={product.title}
                                                     onProductDetailsRequested={this.props.onProductDetailsRequested}
                                                     onGraphFailedToLoad={this.handleGraphLoadingFailure}
                                                     onGraphLoaded={this.handleGraphLoadingSuccess}/>
                            <GraphLegend/>
                            { this.renderAdvancedCard()}
                        </div>
                    </div>
               </div>
    }

    private renderAdvancedCard(){
        const relatedProduct = this.props.relatedProduct;
        if(relatedProduct == null) { return null; }

        return <AdvancedProductCard key={"graph-advanced-card"}
                                    productDescription={relatedProduct}
                                    coverPlaceholder={this.props.coverPlaceholder}
                                    wideCoverPlaceholder={this.props.wideCoverPlaceholder}
                                    onOutsideClick={() => this.props.onProductDetailsRequested(null) }
                                    onAddToReadingListRequest={this.props.onAddToReadingListRequested}
                                    isInAtLeastOneReadingList={relatedProduct.isInReadingList}
                                    outsideClickIgnoredElementsSelector=".product-card-root, .product-card-root img"
                                    style={{
                                        top: 100,//relatedProduct.y, 
                                        left: 50//relatedProduct.x
                                    }}/>
    }

    private handleRootRef(element: HTMLElement){
        this.root = element;
    }

    private handleGraphLoadingFailure(){
        if(this.root == null) { return; }

        const graphContainer: HTMLElement = this.root.querySelector(".product-details-graph-details-part");
        if(graphContainer != null) {
            graphContainer.style.visibility = "hidden";
        }
    }

    private handleGraphLoadingSuccess(){
        if(this.root == null) { return; }

        const graphContainer: HTMLElement = this.root.querySelector(".product-details-graph-details-part");
        if(graphContainer != null) {
            graphContainer.style.visibility = "visible";
        }
    }
}